import { Link } from "react-router-dom";
import { SITE } from "../config/site";

export function Logo({ light = false, className = "" }) {
  return (
    <Link
      to="/"
      data-testid="logo-link"
      className={`flex items-center gap-3 ${className}`}
      aria-label={`${SITE.name} home`}
    >
      <img
        src={SITE.logo}
        alt="CannaCheap DC logo"
        className="h-10 w-10 rounded-full object-cover ring-1 ring-brand-gold/60"
        width="40"
        height="40"
      />
      <span className="leading-none">
        <span
          className={`block font-display text-lg font-black tracking-tight ${
            light ? "text-brand-cream" : "text-brand-forest"
          }`}
        >
          CANNACHEAP
          <span className="text-brand-gold"> DC</span>
        </span>
        <span
          className={`block text-[9px] font-display font-medium uppercase tracking-[0.3em] ${
            light ? "text-brand-cream/60" : "text-brand-pine/60"
          }`}
        >
          {SITE.tagline}
        </span>
      </span>
    </Link>
  );
}
